import { FC, useState } from 'react'
import styled from '@emotion/styled'

const Input = styled('input')(({ theme }) => ({
  font: 'inherit',
  padding: `${theme.spacing.xs + 2}px ${theme.spacing.xs}px`,
  border: '1px solid transparent',
  borderRadius: 0,
  background: 'none',
  color: theme.colors.text.primary,
  textAlign: 'center',
  width: '100%',
  '&:hover': {
    borderColor: theme.colors.primary.main,
  },
  '&:focus': {
    borderColor: theme.colors.primary.main,
  },
  // Hide number input spinners
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    appearance: 'none',
    margin: 0,
  },
  MozAppearance: 'textfield',
}))

interface PreviewQuantityInputProps {
  value: number
  integer?: boolean
  onChange: (value: number) => void
  onFocus?: () => void
  autoFocus?: boolean
}

export const PreviewQuantityInput: FC<PreviewQuantityInputProps> = ({ value, integer, onChange, onFocus: onFocusProp, autoFocus }) => {
  const [draft, setDraft] = useState<string>(() => String(value))
  const [focused, setFocused] = useState(false)

  return (
    <Input
      type="number"
      min={integer ? 1 : 0.01}
      step={integer ? 1 : 0.01}
      value={focused ? draft : value}
      autoFocus={autoFocus}
      onFocus={() => {
        setDraft(String(value))
        setFocused(true)
        onFocusProp?.()
      }}
      onChange={(e) => {
        const raw = e.target.value
        setDraft(raw)

        const num = integer ? parseInt(raw, 10) : parseFloat(raw)
        if (num > 0) {
          onChange(num)
        }
      }}
      onBlur={() => {
        setFocused(false)
        setDraft(String(value))
      }}
    />
  )
}
